class SearchModal extends HTMLElement {
    constructor() {
      super();
      
      this.modal = this.querySelector('.search-modal');
      this.detailsContainer = this.querySelector('details');
      this.summaryToggle = this.querySelector('summary');
      this.input = this.querySelector('.search__input')
      this.searchField = this.summaryToggle.querySelector('.search-field__text')
  
      this.detailsContainer.addEventListener(
        'keyup',
        (event) => event.code && event.code.toUpperCase() === 'ESCAPE' && this.close()
      );
    
        if (this.searchField) {
          this.summaryToggle.querySelector('.search-field__text').addEventListener('input', this.open.bind(this))
         
        } else {
          this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this))
        }

      this.querySelector('button[type="reset"]').addEventListener(
        'click',
        this.reset.bind(this)
      );
        
      this.summaryToggle.setAttribute('role', 'button');
    }

    onSummaryClick(event) {
      event.preventDefault();
      event.target.closest('details').hasAttribute('open')
        ? this.close()
        : this.open(event);
    }
  
    onBodyClick(event) {
      if (!this.contains(event.target) || event.target.classList.contains('overlay') || event.target.closest('.button-close')) this.close();
    }
  
    open() {
      this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
      this.detailsContainer.setAttribute('open', true);
      this.detailsContainer.querySelector('.overlay').classList.add('open')
      document.body.addEventListener('click', this.onBodyClickEvent);
      document.body.classList.add('search-modal--open');
      document.body.classList.add('hidden')
      this.modal.classList.add('open')
      if (this.modal.closest('.shopify-section-footer')) this.modal.closest('.shopify-section-footer').style.zIndex = 20
      if (this.modal.closest('.menu-drawer__content')) this.modal.closest('.menu-drawer__content').style.zIndex = 20
      if (this.modal.closest('.secondary-sidebar-section')) this.modal.closest('.shopify-section-footer').style.zIndex = 20
      if (this.searchField) {
        this.input.setAttribute('value', this.searchField.value)
        this.input.value = this.searchField.value
        trapFocus(
          this.searchField,
          this.input
        );
        this.input.addEventListener('focus', this.input.setSelectionRange(this.searchField.value.length, this.searchField.value.length))
      }
      else {
        trapFocus(
          this.detailsContainer.querySelector('[tabindex="-1"]'),
          this.detailsContainer.querySelector('input:not([type="hidden"])')
        );
      }
    }
  
    close() {
      removeTrapFocus();
      this.detailsContainer.removeAttribute('open');
      this.detailsContainer.querySelector('.overlay').classList.add('close')
      this.detailsContainer.querySelector('.overlay').classList.remove('open')
      document.body.removeEventListener('click', this.onBodyClickEvent);
      document.body.classList.remove('search-modal--open');
      document.dispatchEvent(new CustomEvent('searchmodal:close'));
      document.body.classList.remove('hidden')
      this.querySelector('.search__button-text').classList.add('hidden')
      this.modal.classList.remove('open')
      if (this.searchField) this.searchField.value = ''
      this.input.value = ''
      if (this.closest('.menu-drawer')) this.closest('.menu-drawer').setAttribute('hidden', 'true')
      if (this.modal.closest('.shopify-section-footer')) this.modal.closest('.shopify-section-footer').style.zIndex = 1
      if (this.modal.closest('.menu-drawer__content')) this.modal.closest('.menu-drawer__content').style.zIndex = 10
      if (this.modal.closest('.secondary-sidebar-section')) this.modal.closest('.shopify-section-footer').style.zIndex = 10
    }
  
    reset(event) {
      event.preventDefault();
      this.querySelector('input[type="search"]').value = '';
    }
  }
  
  customElements.define('search-modal', SearchModal);
  